import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { FollowOrderPageRoutingModule } from './follow-order-routing.module';

import { FollowOrderPage } from './follow-order.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FollowOrderPageRoutingModule
  ],
  declarations: [FollowOrderPage]
})
export class FollowOrderPageModule {}
